import errorMessages from './errorMessages';

export function getErrorMessage (errorCode, Locale) {
  const currentLocale = Locale || 'pt-BR';

  const keys = errorCode.split('.');

  let content = errorMessages[currentLocale]

  for (const key of keys) {
    if (!Object.hasOwn(content, key)) {
      return content.generic ?? errorMessages[currentLocale].generic
    }
    content = content[key];
  }
  return content?.generic ?? content
}
